import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/plat/admin/track/event/analyse/"

function baseApi() {

    function analyseTrackEvent(data) {
        return Post(baseUrl + 'view', data);
    }

    function temporaryAnalyseTrackEvent(data) {
        return Post(baseUrl + 'temporaryView', data);
    }

    function deleteAnalyseCache(data) {
        return Post(baseUrl + 'deleteAnalyseCache', data);
    }

    return {
        analyseTrackEvent,
        temporaryAnalyseTrackEvent,
        deleteAnalyseCache
    };
}

export const trackEventAnalyseApi = baseApi()
